import React from 'react';
import { RGBA_COLORS, TEXT_COLORS } from '@/common/presentation/constants/colors';

interface PinShapeProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const PinShape: React.FC<PinShapeProps> = ({
  width = 42,
  height = 50,
  fill = TEXT_COLORS.WHITE,
  className = '',
  onClick,
  style,
  children
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={style}
    >
      {/* Shadow underneath */}
      <ellipse cx="24" cy="54" rx="8" ry="2" fill={RGBA_COLORS.GRAY_20} filter="blur(1px)" />

      <g filter="url(#filter0_ddd_18651_15275)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 2C35.598 2 45 11.402 45 23C45 31.8926 39.4727 39.4942 31.6663 42.5567L25.1961 51.4007C25.0612 51.5858 24.8821 51.7369 24.6739 51.8412C24.4657 51.9455 24.2346 52 24 52C23.7654 52 23.5343 51.9455 23.3261 51.8412C23.1179 51.7369 22.9388 51.5858 22.8039 51.4007L16.3337 42.5567C8.52726 39.4941 3 31.8926 3 23C3 11.402 12.402 2 24 2Z"
          fill={fill}
        />
      </g>
      {children && (
        <foreignObject x="7" y="6" width="34" height="34">
          {children}
        </foreignObject>
      )}
      <defs>
        <filter
          id="filter0_ddd_18651_15275"
          x="0"
          y="0"
          width="48"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow_18651_15275" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_18651_15275" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_18651_15275" result="effect2_dropShadow_18651_15275" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_18651_15275" result="effect3_dropShadow_18651_15275" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_18651_15275" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default PinShape;
